"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('battery-charge', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    transform: "translate(4.000000, 14.000000)"
  }, _react.default.createElement("path", {
    d: "M27,0 L33.75,0 C34.9926407,0 36,0.994922778 36,2.22222222 L36,17.7777778 C36,19.0050772 34.9926407,20 33.75,20 L27,20 M9,20 L2.25,20 C1.00735931,20 0,19.0050772 0,17.7777778 L0,2.22222222 C0,0.994922778 1.00735931,0 2.25,0 L2.25,0 L9,0",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("polyline", {
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    points: "18.001986 0 13 10.0011902 23.003972 10.0011902 18 20"
  }), _react.default.createElement("path", {
    d: "M38,6 L40,6 C41.1045695,6 42,6.8954305 42,8 L42,12 C42,13.1045695 41.1045695,14 40,14 L38,14 L38,6 Z",
    fill: props.outStrokeColor
  }))));
});

exports.default = _default;